import {styled} from "@mui/material";
import {HoverElevationButton} from "./base-buttons";

export const ParcelEditDefaultButton = styled(HoverElevationButton)(() => ({
    width: '1.5rem',
    height: '1.5rem',
    minWidth: 'unset',
    borderRadius: '50%',
}));

export const ParcelEditRemoveButton = styled(ParcelEditDefaultButton)(({theme}) => ({
    backgroundColor: theme.barekam.orderPopup.parcelTable.buttons.background.remove,
}));

export const ParcelEditToAntherOrderButton = styled(ParcelEditDefaultButton)(({theme}) => ({
    backgroundColor: theme.barekam.orderPopup.parcelTable.buttons.background.toAnotherOrder,
    color: '#FFF',

    '&:hover': {
        backgroundColor: theme.barekam.orderPopup.parcelTable.buttons.background.toAnotherOrder,
    },
}));

export const ParcelEditCreateNewOrderButton = styled(ParcelEditDefaultButton)(({theme}) => ({
    backgroundColor: theme.barekam.orderPopup.parcelTable.buttons.background.newOrder,
    color: '#FFF',

    '&:hover': {
        backgroundColor: theme.barekam.orderPopup.parcelTable.buttons.background.newOrder,
    },
}));

export const ParcelEditAddDescriptionButton = styled(ParcelEditDefaultButton)(() => ({
    width: '2rem',
    height: '2rem'
}));
